<template>
  <!-- 弹窗 -->
  <div class="TK_BOX">
    <div class="main" :style="'width:' + `${width}` + 'px'">
      <p class="title"><span></span>{{ title || "" }}</p>
      <div class="tk_main">
        <slot></slot>
      </div>
    </div>
  </div>
  <!-- 弹窗 -->
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: function () {
        return "默认";
      },
    },

    width: {
      type: String,
      default: "",
    },

    heigth: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style lang="less">
// 弹框
.TK_BOX {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: rgba(000, 000, 000, 0.5);

  .main {
    width: 500px;

    margin: auto;
    background: #fff;
    transform: translate(-50%, -50%);
    position: fixed;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;

    .tk_main {
      padding: 15px;
      box-sizing: border-box;

      .tk_li_title {
        width: 100px;
        flex-shrink: 1;
      }
    }

    .el-select {
      width: 100%;
      margin-left: 0px !important;
    }

    .title {
      width: 100%;
      height: 50px;
      background: #eee;
      padding: 0px 10px;
      line-height: 50px;

      span {
        border-left: 3px solid #999;
        margin-right: 10px;
      }
    }

    .el-date-editor {
      width: 100%;
    }

    .inputVle {
      width: 100%;
      box-sizing: border-box;
      margin: 8px auto;
    }

    .btnBox {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popupBox.vue